<template>
    <div>
        <div v-if="isVisible()">
            <timeline :steps="this.steps" :current="this.current" :stepNo="this.stepNo"></timeline>
            <div class="o-content__mob-main-column">
                <router-view></router-view>
            </div>
        </div>
        <div v-else class="a-loader--big__container">
            <div class="a-loader--big"></div>
        </div>
    </div>
</template>
<script>
    import Timeline from 'components/Timeline.vue';
    import {mapGetters, mapActions} from 'vuex';

    export default {
        name: 'DependencyClaim',
        components: {
            Timeline
        },
        /**
         * Note: All of the below can be replaced as a mixin.
         *
         * QT-687 - https://bclegal.atlassian.net/browse/QT-687
         */
        mounted() {
            this.resetOrLoad(this.$route);
        },
        watch: {
            /**
             * Watch $route changes so that existing claims can be saved and
             * closed (coming soon), and the new claim can be loaded out.
             */
            '$route'(to, from) {
                this.resetOrLoad(to);
            }
        },
        computed: {
            ...mapGetters('fatal/dependency/step', {
                steps: 'allSteps',
                current: 'currentStep',
                stepNo: 'currentStepIndex'
            }),
            ...mapGetters('claim', {claimId: 'id'}),
        },
        methods: {
            ...mapActions('claim', ['load', 'reset', 'initialise']),
            ...mapActions('menu', ['updateMenu']),
            /**
             * Should the step be visible or is it 'loading'...
             * @return {Boolean} []
             */
            isVisible() {
                /**
                 * Current route matches Claim ID in state.
                 */
                if (this.$route.params.id == this.claimId) {
                    return true;
                }

                /**
                 * No claim ID in current route, presumably a new claim has been entered.
                 * Since we have a Claim ID in the state we will go ahead and show.
                 */
                if (!this.$route.params.id && this.claimId) {
                    return true;
                }

                return false;
            },
            /**
             * Reset or Load a Claim.
             *
             * If the Route has an ID set, we'll load out the claim,
             * otherwise we reset the form back to it's original state.
             *
             * @param  {Object} route
             */
            resetOrLoad(route) {
                let id = route.params.id;

                if (!id) {
                    return this.reset()
                        .then(() => {
                            this.initialise('fatal_accident_dependency');
                        });
                }

                if (this.claimId === parseInt(id)) {
                    return;
                }

                this.load({claim: {id}, router: this.$router});
            },
        }
    }
</script>


// WEBPACK FOOTER //
// DependencyClaim.vue?8f132a94